$(document).ready(function () {

  // ======== PRODUCT PAGE ACCORDION SLIDER =======
  
  $(".product__description").each(function() {
    if ($(this).find(".metafield-single_line_text_field-array").length) {
      $(this).addClass("metafield-slider");
    }
  });
  
  $(".symbol-slider, .metafield-slider").slick({
    dots: true,
    infinite: false,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    centerMode: true,
    adaptiveHeight: true,
    // responsive: [
    //   {
    //     breakpoint: 749,
    //     settings: {
    //       infinite: true,
    //       dots: true,
    //     },
    //   },
    // ],
  });

  // ======== PRODUCT PAGE ADD TO CART BTN SCROLL =======
  
  $('#sticky-add-to-cart').click(function() {
    var buyButtons = $('.product-form');
    var headerHeight = $('.shopify-section-header-sticky').outerHeight();
    var targetOffset = buyButtons.offset().top;
    
    var scrollToPosition = targetOffset - headerHeight;
    $('html, body').animate({
        scrollTop: scrollToPosition
    }, 1000);
  });

  // ========= PRODUCT PAGE TABS =========
  
$(document).ready(function () {
    // Open the first tab by default
    $('.reinsuranceButton').first().addClass('active');
    $('.infoContent').first().slideDown();

    $('.reinsuranceButton').click(function () {
        var index = $(this).attr('id').replace('tab-button', '');
        var $content = $('#tab-content' + index);
        var $button = $(this);

        // Close all other tabs and remove active class
        $('.reinsuranceButton').removeClass('active');
        $('.infoContent').slideUp();

        // Toggle the clicked tab
        if ($content.is(':hidden')) {
            $button.addClass('active');
            $content.stop(true, true).slideDown();
        }
    });
});

});


$(document).ready(function () {
  var $mediaSection = $(".product__media-wrapper"); // Media section selector
  var $productInfoWrapper = $(".product__info-wrapper"); // Element to toggle the class
  var $productOuter = $(".product__outer"); // Selector for the outer product container
  var activeClass = "active"; // Class to add/remove

  // Function to update the height of product__outer based on the total image heights
  function updateProductOuterHeight() {
    var totalHeight = 0;

    // Calculate the total height of only the Swiper images inside the media section
    $mediaSection.find(".swiper-slide img").each(function () {
      var $img = $(this);
      var imgHeight = $img.height(); // Get the visible height of each image
      if (imgHeight > 0) {
        totalHeight += imgHeight; // Add only visible images' heights
      }
    });

    // Dynamically set the height of product__outer
    if (totalHeight > 0) {
      $productOuter.css("min-height", totalHeight + "px");
    }
  }

  // Initial call to update the height on page load, only if window width is >= 991
  if ($(window).width() >= 991) {
    updateProductOuterHeight();
  }

  // Update the height on window resize to keep it in sync with the images' height
  $(window).resize(function () {
    if ($(window).width() >= 991) {
      updateProductOuterHeight();
    }
  });

  // Update the height after images are loaded
  $mediaSection.find(".swiper-slide img").on("load", function () {
    if ($(window).width() >= 991) {
      updateProductOuterHeight();
    }
  });

  // Scroll event
  $(window).on("scroll", function () {
    if ($(window).width() >= 991) { // Only run the sticky logic if width is >= 991px
      var mediaTop = $mediaSection.offset().top; // Top of the media section
      var mediaBottom = mediaTop + $mediaSection.outerHeight(); // Bottom of the media section
      var scrollTop = $(window).scrollTop(); // Current scroll position
      var windowHeight = $(window).height(); // Viewport height

      // Calculate the offset of the .product__info-wrapper relative to the document
      var productInfoTopOffset = $productInfoWrapper.offset().top;

      // Dynamically calculate the 'top' value based on the scroll position of the page
      var dynamicTopOffset = scrollTop - productInfoTopOffset + windowHeight * 0.2; // Adjust based on the page scroll

      // Check if the media section is within the viewport (top and bottom)
      if (scrollTop + windowHeight > mediaTop && scrollTop < mediaBottom) {
        // Add the class when the media image is in view
        if (!$productInfoWrapper.hasClass(activeClass)) {
          $productInfoWrapper.addClass(activeClass);
        }

        // Apply sticky positioning for the product info wrapper
        $productInfoWrapper.css({
          "top": "20px" // Sticky top offset (can be dynamically adjusted)
        });

        // Apply sticky positioning for the media section as well
        $mediaSection.css({
          "top": "20px" // Sticky top offset for media section
        });

        // Call the function to update the height of the product__outer when the media image is in view
        updateProductOuterHeight();
      } else {
        // Remove the class once the media section is completely out of the viewport
        if ($productInfoWrapper.hasClass(activeClass)) {
          $productInfoWrapper.removeClass(activeClass);
        }

        // Reset the sticky position for both elements when out of view
        $productInfoWrapper.css({
          "top": ""
        });

        $mediaSection.css({
          "top": ""
        });
      }
    }
  });
});
// document.addEventListener("DOMContentLoaded", () => {
//   const checkoutForm = document.querySelector(".checkout-form"); // Select the checkout form
//   const stickyAddToCart = document.getElementById("fixed-sticky-bar"); // Sticky add-to-cart button

//   // Function to check if the element is fully out of the viewport
//   const isFullyOutOfViewport = (element) => {
//     const rect = element.getBoundingClientRect();
//     // Check if the bottom of the element is above the viewport
//     return rect.bottom < 0 || rect.top >= (window.innerHeight || document.documentElement.clientHeight);
//   };

//   // Function to toggle visibility of sticky add-to-cart
//   const toggleStickyAddToCart = () => {
//     if (checkoutForm && stickyAddToCart) {
//       if (isFullyOutOfViewport(checkoutForm)) {
//         stickyAddToCart.style.display = "block"; // Show sticky add-to-cart
//       } else {
//         stickyAddToCart.style.display = "none"; // Hide sticky add-to-cart
//       }
//     }
//   };

//   // Event listeners for scroll and resize
//   window.addEventListener("scroll", toggleStickyAddToCart);
//   window.addEventListener("resize", toggleStickyAddToCart);

//   // Initial check
//   toggleStickyAddToCart();
// });


document.addEventListener("DOMContentLoaded", () => {
  const checkoutForm = document.querySelector(".checkout-form"); // Select the checkout form
  const stickyAddToCart = document.getElementById("fixed-sticky-bar"); // Sticky add-to-cart button

  let lastScrollPosition = window.scrollY; // Store the last scroll position
  let stickyVisible = false; // Track the visibility state of the sticky button

  // Function to check if the element is fully out of the viewport
  const isFullyOutOfViewport = (element) => {
    const rect = element.getBoundingClientRect();
    // Check if the bottom of the element is above the viewport
    return rect.bottom < 0;
  };

  // Function to check the scroll direction
  const isScrollingDown = () => {
    const currentScrollPosition = window.scrollY;
    const scrollingDown = currentScrollPosition > lastScrollPosition;
    lastScrollPosition = currentScrollPosition;
    return scrollingDown;
  };

  // Function to toggle visibility of sticky add-to-cart
  const toggleStickyAddToCart = () => {
    if (checkoutForm && stickyAddToCart) {
      // Check if the form is fully out of view
      if (isFullyOutOfViewport(checkoutForm)) {
        // If scrolling down or already visible, show the sticky button
        if (isScrollingDown() || stickyVisible) {
          stickyAddToCart.style.display = "block";
          stickyVisible = true;
        }
      } else {
        // If the form is in view, hide the sticky button
        stickyAddToCart.style.display = "none";
        stickyVisible = false;
      }
    }
  };

  // Event listeners for scroll and resize
  window.addEventListener("scroll", toggleStickyAddToCart);
  window.addEventListener("resize", toggleStickyAddToCart);

  // Initial check
  toggleStickyAddToCart();
});



